import RandingStyle4 from "../../randing/RandingStyle4";
// import { Helmet } from "react-helmet";

function Randing008({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <RandingStyle4
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_01.jpg`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/008/241108_01.webp`}
        img3Path={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_06.jpg`} // 스텝 변경되는 이미지
        numberColor="#3f8c58"
        benefitInfoPosition="top"
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_05.png`}
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
        articleOption={true}
      />
    </>
  );
}

export default Randing008;
